import React from 'react'
import SearchIconBold from './SearchIconBold'
import Translation from '../General/Translation'
import SearchIconThin from './SearchIconThin'

const MovieSearchTextDisplay = ({
    iconThin=true,
    translation
}) => (
    <div className="search-display">
        <div className="search-text">
            <Translation id="search" trans={translation}>Suche</Translation>
        </div>
        <div className="search-icon">
            {iconThin ? <SearchIconThin /> : <SearchIconBold />}
        </div>
    </div>
)

export default MovieSearchTextDisplay